import { render, staticRenderFns } from "./ControllerForm.vue?vue&type=template&id=1ed12838&"
import script from "./ControllerForm.vue?vue&type=script&lang=js&"
export * from "./ControllerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports